/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("Testimonials", ["jquery", "Behaviors"], factory);
    } else {
        root.Testimonials = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    var moduleInstanceId;

    function Testimonials(target) {
       
        //handle multiple instances in one page

        this.moduleInstanceId = '.fl-node-' + target.getAttribute( 'data-testimonials' );

        Behaviors.init(Testimonials, this, arguments);

        this.element = this.$elem[0];

        this.initOwlCarousel( this.moduleInstanceId  );

    }

    Behaviors.inherit(Testimonials, Behaviors.Behavior);

    Testimonials.QUERY = "[data-testimonials]";

    Testimonials.ELEMENTS = {
        testimonialItem: " .testimonial-item",
        carousel: " .Testimonials .owl-carousel",
    };

    Testimonials.prototype.initOwlCarousel = function(instanceId) {
       

        if($(Testimonials.ELEMENTS.carousel).length){


            this.carousel = $( instanceId + Testimonials.ELEMENTS.carousel).owlCarousel({
                loop:  true,
                dots: true,
                autoplay: true,
                items: 1,
                slideBy: 1,
                autoplayTimeout:10000 
               
            });

        }
 
    };
    
    Behaviors.register_behavior(Testimonials);

    module.Testimonials = Testimonials;

    // window.addEventListener("resize", function () {
        
    //     if(this.innerWidth > 992){
    //         if( $(Testimonials.ELEMENTS.carousel).length )
    //             Testimonials.prototype.carousel.trigger('destroy.owl.carousel');

    //     }else{
    //         if( $(Testimonials.ELEMENTS.carousel).length )
    //             Testimonials.prototype.initOwlCarousel();
    //     }
    // });

    return module;
}));
